import { Tooltip, Typography } from '@mui/material';
import React from 'react';

const ScopeCell = React.memo((row: any) => (
  <span>
    {row?.scope?.name && (
      <Tooltip title={row.scope.name}>
        <Typography variant="body2" noWrap>
          {row.scope.name}
        </Typography>
      </Tooltip>
    )}
  </span>
));

export default ScopeCell;
